// The shell collapses the session sidebar when it mounts on a Proof focus
// URL (`?pane=proof-report:<child>&focus=proof`), GitHub's Proof links' layout.
// The palette pushes the same URL from inside the app, possibly from a route
// outside the shell (the org home), where the shell mounts fresh; this mark
// tells that mount apart from an arrival.
let markedChildSessionId: string | null = null;

/** Called right before an in-app push to `childSessionId`'s report. */
export function markInAppProofFocusNavigation(childSessionId: string) {
  markedChildSessionId = childSessionId;
}

/**
 * Whether the Proof focus URL the shell mounts on, showing `childSessionId`'s
 * report, came from an in-app push. Reading consumes the mark, so a push that
 * never remounted the shell cannot speak for a later arrival on another Proof.
 */
export function takeInAppProofFocusNavigation(
  childSessionId: string | null,
): boolean {
  const marked = markedChildSessionId;
  markedChildSessionId = null;
  return childSessionId !== null && marked === childSessionId;
}
